import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router";
import api from "../../../../../../api/api";
import { useAuth } from "../../../../../../features/auth/AuthContext";
//import "../../../../styles/dashboard.css";
//import "../../../../styles/r-style.css";
import imgs from "../../../../../../assets/images/imgs";
import { updateGlobalState } from "../../../../../../state/global/slice";
import { useDispatch, useSelector } from "react-redux";
import { devicon_linkedin, calendar_31 } from "../../../../../../assets/images/images";
import { CircularProgress, Grid, Pagination } from "@mui/material";
import StudentCourseCard from "../course/StudentCourseCard";
import StudentSuggesionCourseData from "../course/StudentSuggesionCourseData";
import BackButton from "../../../../../../components/BackButton/BackButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { set } from "date-fns";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import { resetAddToCart } from "../../../../../../state/reducers/addToCartReducer";
import RateTeacherPopup from "../../../../../../components/TeacherRatingPopup/TeacherRatingPopup";
import RatingPopup from "../../../../../../components/TeacherRatingPopup/TeacherRatingPopup";
import FloatingAIButton from "../../../../../../components/FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../../../../../state/reducers/chatDrawerReducers";
import BookingModal from "./BookingModal";
//import "../../../../styles/"
// import BackButton from "../../../../../../components/BackButtonFolder/BackButtonFolder";

const TeacherProfileSetting = () => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const { teacher_id } = useParams();
  const [getinfotecher, setinfoteacher] = useState({});

  const [gettechercoursedtls, settechercoursedtls] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const addToCartData = useSelector((state) => state.addToCart); 
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const [showRatingTooltip, setShowRatingTooltip] = useState(false);
  const [showRatePopup, setShowRatePopup] = useState(false);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [preFilledSessionData, setPreFilledSessionData] = useState(null);
  const globalState = useSelector((state) => state.globalState);
  const student_id = globalState?.student_details?.data?.student_id;
  const isGoogleMeet = globalState.enabled_modules?.includes('google_meet');
  
  const [totalPages, setTotalPages] = useState(0);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const PAGE_SIZE = 12;


  const dispatch = useDispatch();

  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };



  const fetchTeacherbyTeacherid = async (page = 1) => {
    try {
      setLoading(true);
      const response = await api.get(`/courses/get-all-courses/teacher/${teacher_id}/`, {
        params: {
          page,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (response.status === 200) {
        const responseData = response?.data ?? {};

        settechercoursedtls(responseData?.data ?? []);
        setNextUrl(responseData?.next ?? null);
        setPrevUrl(responseData?.previous ?? null);
        const count = responseData?.count ?? 0;
        setTotalPages(Math.ceil(count / PAGE_SIZE));
        //console.warn("gettechercoursedtls", gettechercoursedtls);

        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }



  const fetchTeacherCoursebyTeacherid = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/auth/get-teacher-by-teacher-id/${teacher_id}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      if (response.status === 200) {
        // updateState("teacher_details", response?.data ?? {});
        setinfoteacher(response?.data?.data ?? []);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);

    }
  }






  // useEffect(() => {
  //   document.body.style.overflow = "auto";
  //   api
  //     .get(`/auth/get-teacher-by-teacher-id/${teacher_id}/`, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Token ${token}`,
  //       },
  //     })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         updateState("teacher_details", response?.data ?? {});
  //         setinfoteacher(response?.data?.data ?? []);
  //       }
  //     })
  //     .catch((error) => {
  //       //
  //     });

  //   api
  //     .get(`/courses/get-all-courses/teacher/${teacher_id}/`, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Token ${token}`,
  //       },
  //     })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         settechercoursedtls(response?.data?.data ?? []);
  //       }
  //     })
  //     .catch((error) => {
  //       //
  //     });
  // }, [teacher_id]);

  useEffect(() => {
    fetchTeacherCoursebyTeacherid()
  }, [teacher_id])

  // courses list is paginated, so it refetches on teacher change and page change
  useEffect(() => {
    fetchTeacherbyTeacherid(currentPage)
  }, [teacher_id, currentPage])

  const statusPriority = (status) => {
    switch (status) {
      case "Pending":
        return 1;
      case "Active":
        return 2;
      default:
        return 3;
    }
  };



  let coursesSortedArray = [];

  if (
    Array.isArray(gettechercoursedtls)) {
    coursesSortedArray = [...gettechercoursedtls].sort((a, b) => {
      return statusPriority(a.status) - statusPriority(b.status);
    });
  }

  //console.warn("studentside teacher suggested course list", coursesSortedArray);


  let myCourseArray = [];

  if (Array.isArray(getinfotecher?.my_course) && getinfotecher.my_course.length) {
    myCourseArray = [...getinfotecher.my_course];
  }

  const handleNavigateAway = () => {
    localStorage.setItem("studentHomeScrollPosition", window.pageYOffset);
  };

  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
  };

    //   useEffect(() => {
    //     if (addToCartData?.source !== 'TeacherProfileSetting') return;
    //     if (addToCartData?.message?.length) {
    //         toast.success(addToCartData?.message);
    //     }
    //     if (addToCartData?.error?.length) {
    //         toast.error(addToCartData?.error);
    //     }
    //     return () => {
    //         dispatch(resetAddToCart());
    //     };
    // }, [addToCartData]);
const fromPath     = location.state?.from;
  const subjectId    = location.state?.subjectId;
  const subjectName  = location.state?.subjectName;

  const handleBack = () => {
    if (fromPath && subjectId) {
      navigate(fromPath, {
        state: {
          subjectId:   subjectId,
          subjectName: subjectName,
        },
      });
    } else {
      navigate(-1); // fallback
    }
  };

  return (
    <>
      <section className="teacher_profile_set_sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="teacher_profile_set_sec_inner">
                <div className="view-course-Details-back-btn-folder LessonViewProgress-back-btn-folder">
                  <BackButton
                    buttonName="Back"
                    // fallbackPath={"/dashboard/departments" || "dashboard/my-department"}
                    handleClick={handleBack}
                  />
                </div>
                <div className="teacher_profile_body">
                  <h6>Teacher Profile</h6>
                  
                  <div className="subject_special_sec">
                    <h5>Specialization</h5>
                    <ul>
                      {getinfotecher?.subjects &&
                      Object.values(getinfotecher?.subjects).length > 0 ? (
                        Object.values(
                          getinfotecher?.subjects,
                        ).map((subject, index) => <li key={index}>{subject}</li>)
                      ) : (
                        <h6>No Specialization are selected</h6>
                      )}
                    </ul>
                  </div>
                  <div className="about_teach_main_profile">
                    <div className="teacher_profile_about_teacher">
                      <div className="about_teacher_img">
                        <div className="about_teach_sec_new_left">
                          <div className="about_left_pic">
                            <img
                              src={getinfotecher?.ai_avatar || imgs.png.ab_img}
                              alt=""
                            />
                          </div>
                          <h5>{getinfotecher?.name}</h5>
                          {globalState.enabled_modules?.includes(
                            "marketplace",
                          ) && (
                            <div className="studentDashboar-Suggested-Courses-profile-rate !flex-row items-baseline justify-center">
                              <a
                                onClick={() => {
                                  if (myCourseArray.length === 0) return;
                                  setShowRatePopup(true);
                                }}
                                style={{
                                  cursor: myCourseArray.length === 0 ? "not-allowed" : "pointer",
                                  pointerEvents: myCourseArray.length === 0 ? "not-allowed" : "auto",
                                }}
                              >
                                <i className="fa-solid fa-star"></i>
                              </a>
                              <p className="rate"
                                onClick={() => {
                                    if (myCourseArray.length === 0) return;
                                    setShowRatePopup(true);
                                  }}
                                style={{
                                    cursor: myCourseArray.length === 0 ? "not-allowed" : "pointer",
                                    pointerEvents: myCourseArray.length === 0 ? "not-allowed" : "auto",
                                }}
                              >
                                {getinfotecher?.average_teacher_rating}
                              </p>
                              <span
                                onMouseEnter={() => setShowRatingTooltip(true)}
                                onMouseLeave={() => setShowRatingTooltip(false)}
                                style={{
                                  cursor: "pointer",
                                  fontSize: "16px",
                                  color: "#888",
                                  position: "relative",
                                }}
                              >
                                <InfoOutlinedIcon
                                  onMouseEnter={() =>
                                    setShowRatingTooltip(true)
                                  }
                                  onMouseLeave={() =>
                                    setShowRatingTooltip(false)
                                  }
                                  style={{
                                    fontSize: "18px",
                                    color: "#0c0c0c",
                                    cursor: "pointer",
                                    position: "relative",
                                  }}
                                />

                                {/* Tooltip */}
                                {showRatingTooltip && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "28px",
                                      left: "0%",
                                      // transform: "translateX(-50%)",
                                      background: "#fff",
                                      borderRadius: "12px",
                                      boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                                      padding: "20px",
                                      width: "280px",
                                      zIndex: 999,
                                      pointerEvents: "none",
                                    }}
                                  >
                                    {/* Overall Rating */}
                                    <div
                                      style={{
                                        fontSize: "36px",
                                        fontWeight: "500",
                                        color: "#000",
                                        lineHeight: 1,
                                      }}
                                    >
                                      {getinfotecher?.average_teacher_rating}
                                    </div>

                                    {/* Star Icons */}
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "4px",
                                        margin: "8px 0 4px",
                                      }}
                                    >
                                      {[1, 2, 3, 4, 5].map((star) => {
                                        const rating =
                                          getinfotecher?.average_teacher_rating ??
                                          4.0;
                                        return (
                                          <i
                                            key={star}
                                            className={
                                              star <= Math.floor(rating)
                                                ? "fa-solid fa-star"
                                                : star === Math.ceil(rating) &&
                                                  rating % 1 !== 0
                                                ? "fa-solid fa-star-half-stroke"
                                                : "fa-regular fa-star"
                                            }
                                            style={{
                                              color: "#f5a623",
                                              fontSize: "18px",
                                            }}
                                          />
                                        );
                                      })}
                                    </div>

                                    {getinfotecher?.rating_count > 0 && (
                                      <p style={{ fontSize: "12px", color: "#666", margin: "0 0 12px" }}>
                                        {getinfotecher.rating_count.toLocaleString()} {getinfotecher.rating_count === 1 ? "rating" : "ratings"}
                                      </p>
                                    )}

                                    {/* Star Breakdown */}
                                    {/* Star Breakdown */}
                                    {(() => {
                                      const breakdown =
                                        getinfotecher?.rating_breakdown ?? {};
                                      const total = Object.values(
                                        breakdown,
                                      ).reduce(
                                        (a, b) => Number(a) + Number(b),
                                        0,
                                      );

                                      return [5, 4, 3, 2, 1].map((star) => {
                                        const count = Number(
                                          breakdown[`${star}_star`] ?? 0,
                                        );
                                        const percent =
                                          total > 0 ? (count / total) * 100 : 0;

                                        return (
                                          <div
                                            key={star}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px",
                                              marginBottom: "6px",
                                            }}
                                          >
                                            <span
                                              style={{
                                                fontSize: "13px",
                                                color: "#444",
                                                minWidth: "40px",
                                              }}
                                            >
                                              {star} Star
                                            </span>
                                            <div
                                              style={{
                                                flex: 1,
                                                background: "#e0e0e0",
                                                borderRadius: "4px",
                                                height: "6px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  width: `${percent}%`,
                                                  background: "#1a73e8",
                                                  borderRadius: "4px",
                                                  height: "100%",
                                                }}
                                              />
                                            </div>
                                            <span
                                              style={{
                                                fontSize: "13px",
                                                color: "#444",
                                                minWidth: "20px",
                                                textAlign: "right",
                                              }}
                                            >
                                              {String(count).padStart(2, "0")}
                                            </span>
                                          </div>
                                        );
                                      });
                                    })()}
                                  </div>
                                )}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="about_teacher_cont">
                        <h5>About Teacher</h5>
                        <p>{getinfotecher?.introduction}</p>
                      </div>
                    </div>
                    <div className="profile_linkedin">
                      <div className="profile_linkedin_image">
                        <img src={devicon_linkedin} />
                      </div>
                      <a href={getinfotecher.linkedin_url} target="_blank">
                        {getinfotecher?.linkedin_url ?? "-"}
                      </a>
                    </div>
                  </div>
                  {isGoogleMeet && (
                    <div className="tutoring-types-sec mt-4">
                      <div className="flex gap-3 items-center mb-6">
                        <h4 className="m-0 font-medium text-[18px] text-black">Tutoring Types</h4>
                        <button
                          onClick={() => setShowBookingModal(true)}
                          disabled={!getinfotecher?.is_meeting_enabled}
                          data-tooltip-id="book-meeting-tooltip"
                          className={`text-[14px] px-3 py-2 rounded-lg font-semibold flex items-center gap-2 transition-colors duration-200 border-none ${
                            getinfotecher?.is_meeting_enabled
                              ? "bg-[#0068FF] hover:bg-blue-700 text-white cursor-pointer"
                              : "bg-gray-100 cursor-not-allowed"
                          }`}
                        >
                          <img src={calendar_31} alt="calendar" className={getinfotecher?.is_meeting_enabled ? "" : "bg-[#c0c4c8]"}/>
                          Book a meeting
                        </button>
                        {!getinfotecher?.is_meeting_enabled && (
                          <Tooltip
                            id="book-meeting-tooltip"
                            content="This teacher is not accepting meetings right now."
                            place="top"
                            delayShow={0}
                          />
                        )}
                      </div>

                      {/* 1 on 1 Session */}
                      <div className="mb-6">
                       <div className="flex items-baseline gap-2">
                         <h5 className="text-[#555555] font-semibold mb-3">1 on 1 Session</h5>
                        {globalState?.enabled_modules?.includes("marketplace") && (
                          <div>
                            {getinfotecher?.is_trial && (
                          <span className="free-trial-badge-teacher-profile">Free Trial</span>
                            )}
                          </div>
                        )}
                       </div>
                        <div className="flex flex-wrap gap-3">
                          {getinfotecher?.offerings && getinfotecher.offerings.length > 0 ? (
                            getinfotecher.offerings.map((offering, index) => (
                              <button
                                key={index}
                                disabled={!getinfotecher?.is_meeting_enabled}
                                onClick={() => {
                                  setPreFilledSessionData({
                                    sessionSlot: `${offering.duration_minutes}min`,
                                    sessionType: "one-on-one",
                                  });
                                  setShowBookingModal(true);
                                }}
                                data-tooltip-id="session-chip-tooltip"
                                className={`px-3 py-2 border rounded-md font-medium transition-colors ${
                                  getinfotecher?.is_meeting_enabled
                                    ? "border-gray-300 bg-[#FAFAFA] hover:bg-blue-50 hover:border-blue-400 hover:text-blue-600 cursor-pointer"
                                    : "border-gray-200 bg-gray-100 text-gray-400 cursor-not-allowed"
                                }`}
                              >

                                  <span className="text-sm font-medium">
                                    {offering.duration_minutes} Min. {globalState?.enabled_modules?.includes("marketplace") && (
                                          <>
                                          <span className="ml-1">
                                            {offering.currency_symbol || "$"}
                                            {offering.price}
                                          </span>
                                          </>
                                        )}
                                  </span>

                              </button>
                            ))
                          ) : (
                            <p className="text-gray-600 text-sm">No sessions available</p>
                          )}
                        {!getinfotecher?.is_meeting_enabled && (
                          <Tooltip
                            id="session-chip-tooltip"
                            content="This teacher is not accepting meetings right now."
                            place="top"
                            delayShow={0}
                          />
                        )}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="gray_house_sec">
                    <h5 style={{ fontSize: "18px" }}>Teacher Courses</h5>
                    <div>
                      {loading && (
                        <Grid
                          height={"50vh"}
                          xs={12}
                          container
                          justifyContent="center"
                          alignItems="center"
                        >
                          <CircularProgress size={80} />
                        </Grid>
                      )}
                    </div>

                    {/* {
                        loading  ? 
                          <Grid
                            height={"50vh"}
                            xs={12}
                            container
                            justifyContent={"center"}
                            alignItems={"center"}
                          >
                            <CircularProgress size={80} />
                          </Grid>  
                            :      
                      gettechercoursedtls && gettechercoursedtls.length > 0 ? (
                        gettechercoursedtls.map((value, index) => (
                          <div className="gray_house_sec_single">
                            <div className="gray_house_sec_single_img">
                              <img src={value?.image} alt="" />
                            </div>
                            <div className="gray_house_sec_single_cont">
                              <div className="gray_house_teacher">
                                <img
                                  src={
                                    getinfotecher?.ai_avatar || imgs.png.ab_img
                                  }
                                  alt=""
                                />
                                <span>
                                  <h6>{getinfotecher?.name}</h6>
                                  <p>Teacher</p>
                                </span>
                              </div>
                              <div className="gray_house_teacher_cont_sec_new">
                                <h4>{value?.subject}</h4>
                                <h3>{value?.name}</h3>  
                                <div className="view_cose_det_sec">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      if (value?.status === null || value?.status === "Pending") {  
                                        navigate(`/course/${value?.course_id}/view`,
                                        {
                                          state: {
                                            course: getinfotecher,
                                            isFromInvite: false,
                                          },
                                        });
                                      } else {
                                        navigate(`/course/${value?.course_id}`,
                                          {
                                          state: {
                                            course: getinfotecher,
                                          },
                                        });
                                      }
                                    }}
                                    className="view_course_sec"
                                  >
                                    View Course
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <h6>Course not uploaded yet</h6>
                      )} */}
                    {/* MYCOURSE */}
                    <div className="studentDashboar-Suggested-Courses-container">
                      {loading
                        ? null
                        : myCourseArray?.length > 0 && !loading
                        ? myCourseArray
                            // Map to components
                            .map((course, index) => (
                              <StudentCourseCard
                                onNavigateAway={handleNavigateAway}
                                key={index}
                                course={course}
                              />
                            ))
                        : null}
                    </div>
                    {/* Suggested COURSE */}
                    <div className="studentDashboar-Suggested-Courses-container">
                      {loading
                        ? null
                        : coursesSortedArray?.length > 0 && !loading
                        ? coursesSortedArray
                            // Map to components
                            .map((course, index) => (
                              <StudentSuggesionCourseData
                                onNavigateAway={handleNavigateAway}
                                key={index}
                                course={course}
                              />
                            ))
                        : null}
                    </div>
                    {!loading && coursesSortedArray?.length === 0 && (
                      <div className="no-courses-available-container">
                        <div>No Courses Found</div>
                      </div>
                    )}

                    {/* {showRatePopup && (
                  <RateTeacherPopup
                    teacherName={getinfotecher?.name}
                    teacherRating={getinfotecher?.has_teacher_rating}
                    ratingId={getinfotecher?.teacher_rating_id}
                    studentId={student_id}
                    onClose={() => {
                      setShowRatePopup(false)
                      fetchTeacherCoursebyTeacherid();
                      fetchTeacherbyTeacherid();
                    }}
                    average_teacher_rating={getinfotecher?.average_teacher_rating}
                  />
                )} */}

                    {showRatePopup && (
                      <RatingPopup
                        type="teacher"
                        name={getinfotecher?.name}
                        entityId={teacher_id}
                        studentId={student_id}
                        token={token}
                        ratingId={getinfotecher?.teacher_rating_id}
                        hasRated={getinfotecher?.has_teacher_rating}
                        initialRating={getinfotecher?.average_teacher_rating}
                        onClose={() => {
                          setShowRatePopup(false);
                          fetchTeacherCoursebyTeacherid();
                          fetchTeacherbyTeacherid();
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            {!loading && totalPages > 1 && (
              <div className="container-pagination">
                <Grid xs={12} container justifyContent={"center"}>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                    hideNextButton={nextUrl === null || currentPage === totalPages}
                    hidePrevButton={prevUrl === null || currentPage === 1}
                  />
                </Grid>
              </div>
            )}
          </div>
        </div>
      </section>
      <FloatingAIButton
        onClick={() => {
          dispatch(setDrawerState(!chatDrawerState.isOpen));
          dispatch(setIsWebAllowed(true));
          dispatch(setQueryMetaData(null));
        }}
      />

      {/* Booking Modal Component */}
      <BookingModal
        isOpen={showBookingModal}
        onClose={() => {
          setShowBookingModal(false);
          setPreFilledSessionData(null);
        }}
        teacher={getinfotecher}
        preFilledData={preFilledSessionData}
        globalState={globalState}
      />
    </>
  );
};

export default TeacherProfileSetting;